import config from '@/services/config'
import { getController as getAbortController } from '@/services/abortManager'

const baseURL = config.backendURL || process.env.VUE_APP_BACKEND_URL || ''

const isJsonLike = (body) =>
    body &&
    typeof body === 'object' &&
    !(body instanceof FormData) &&
    !(body instanceof Blob) &&
    !(body instanceof ArrayBuffer) &&
    !(body instanceof URLSearchParams)

const resolveUrl = (path) => {
    if (!path) return baseURL
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path
    }
    return `${baseURL}${path}`
}

const streamFetch = async (path, options = {}) => {
    const {
        method = 'GET',
        headers = {},
        body,
        signal,
        withAuth = true,
        withSubdomain = true,
        abortKey,
    } = options

    let controller = null
    let finalSignal = signal

    if (abortKey) {
        controller = getAbortController(abortKey)
        finalSignal = controller.signal
    }

    const requestHeaders = { ...headers }

    if (withAuth && config.sessionToken && !requestHeaders.Authorization) {
        requestHeaders.Authorization = `Bearer ${config.sessionToken}`
    }

    if (withSubdomain) {
        Object.assign(requestHeaders, config.getSubdomainHeader())
    }

    let requestBody = body
    if (isJsonLike(body)) {
        requestBody = JSON.stringify(body)
        if (!requestHeaders['Content-Type']) {
            requestHeaders['Content-Type'] = 'application/json'
        }
    }

    return fetch(resolveUrl(path), {
        method,
        headers: requestHeaders,
        body: requestBody,
        signal: finalSignal,
    })
}

export default {
    fetch: streamFetch,
}
